//packages
import _ from 'lodash'
import querystring from 'querystring'
import { push } from 'react-router-redux'

//validations
import validations from '../../validations'

//constants
import * as errorConstants from '../../../../redux/actionTypes/errorActionTypes'

const validateInputs = function (search_type, againstPacer) {
  if (againstPacer && !client_code_is_valid()) {
    return {
      messages: ["Please set a valid client code first."]
    };
  }

  const messages = [];
  const fields = [];

  switch (search_type) {
    case 'case_no':
      const case_no = this.props.filters.get('case_no');
      if (!case_no || !validations.CASE_NUMBER_WILDCARD(case_no)) {
        messages.push('Invalid case number format.');
        fields.push('case_no')
      }
      break;
    case 'party_title':
      const party_title = this.props.filters.get('party_title');
      if (party_title && !validations.PARTY_NAME_CASE_TITLE(party_title)) {
        messages.push('Invalid case title format.');
        fields.push('party_title')
      }
  }

  return messages.length ? { messages, fields } : null;
};

const urlUpdate = function (query, search_term) {
  let { court_name, court_code } = query;
  let courts = '';
  let courtCodes = '';

  if (court_name && court_name.includes(',')) {
    delete query.court_name;
    courts = court_name.split(',').reduce((accum, next) => {
      return accum += `&court_name[]=${next}`;
    }, '');
    courts = encodeURI(courts);
  }

  if (court_code && court_code.includes(',')) {
    delete query.court_code;
    courtCodes = court_code.split(',').reduce((accum, next) => {
      return accum += `&court_code[]=${next}`;
    }, '');
    courtCodes = encodeURI(courtCodes);
  }


  const queriesStringifed = querystring.stringify({
    ...query, search_term,
  });

  this.props.dispatch(function (dispatch, state) {
    dispatch(push(`/filings/search-court-filings?${queriesStringifed}${courts}${courtCodes}`));
  });
};

export const search = function (filter = {}, againstPacer = true) {
  const filters = this.props.filters;
  console.log("Overide Filter", filter, "Filters", filters.toJS());

  const search_type = filter.search_type || filters.get('search_type');
  const searchTypeQueryName = search_type === 'case_no' && !_.isEmpty(filters) ? 'case_no' : 'party_title';

  const searchValue = searchTypeQueryName === 'party_title' && !filters.get(search_type) ? '*' : filters.get(search_type);

  const case_type = filter.case_type || filters.get('case_type');

  const query = _.pickBy({
    case_type: /all/i.test(case_type) ? null : case_type.toLowerCase(),
    filed_from: !_.isUndefined(filter.filed_from) ? filter.filed_from : filters.get('filed_from') && filters.get('filed_from').format('MM/DD/YYYY'),
    filed_to: !_.isUndefined(filter.filed_to) ? filter.filed_to : filters.get('filed_to') && filters.get('filed_to').format('MM/DD/YYYY'),
    order: !_.isUndefined(filter.order) ? filter.order : filters.get('order'),
    sort: !_.isUndefined(filter.sort) ? filter.sort : filters.get('sort'),
    year: !_.isUndefined(filter.year) ? filter.year : filters.get('year'),
    chapter: !_.isUndefined(filter.chapter) ? filter.chapter : filters.get('chapter'),
    court_name: !_.isUndefined(filter.court_name) ? filter.court_name : filters.get('court_name'),
    page: !_.isUndefined(filter.page) ? filter.page : filters.get('page'),
    court_code: !_.isUndefined(filter.region_name) ? filter.region_name : (filters.get('region_name') || ''),
  }, _.identity);

  const validationErrors = validateInputs.bind(this)(searchTypeQueryName, againstPacer);

  if (validationErrors) {
    this.props.errorActions.receiveError(errorConstants.VALIDATION_ERROR, validationErrors);
  } else {
    urlUpdate.bind(this)({ ...query, ...{ search_type } }, searchValue);
    this.props.actions.partySearch(query, searchTypeQueryName, searchValue);
  }
};


// WEBPACK FOOTER //
// ./src/components/search/sections/util/caseLookup.js